"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const transactionSigningSagas_1 = __importDefault(require("@/features/transaction-signing/sagax/transactionSigningSagas"));
const login2FASagas_1 = __importDefault(require("@/features/login2fa/sagas/login2FASagas"));
function* rootSaga() {
    yield (0, effects_1.all)([...transactionSigningSagas_1.default, ...login2FASagas_1.default]);
}
exports.default = rootSaga;
